import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './WhatsonHeader.css';
import React from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../utils';
import RouterLink from '../atoms/RouterLink/RouterLink';
import { Text, Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var WhatsonHeader = function WhatsonHeader(_ref) {
  var rendering = _ref.rendering,
    fields = _ref.fields,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var theme = get(sitecoreContext, 'themesOfPage');
  var contexItem = get(fields, 'data.contexItem');
  var pageTitle = get(contexItem, 'title.jss');
  var pageIntro = get(contexItem, 'introText.jss');
  var contextLink = get(contexItem, 'url');
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var themeColor = get(params, 'Color', '');
  var items = get(fields, 'data.whatsOnPage.children') || [];
  var itemsLength = items.filter(function (item) {
    return get(item, 'title.jss.value') && get(item, 'navigationCategory.value.title.jss.value');
  });
  var whatsOnItemUrl = get(fields, 'data.whatsOnPage.url');
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex', '#fff');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var Color = get(params, 'Color') || '';
  var variables = BackgroundColorHex ? {
    "--m57-whatson-header-color": ColorHex,
    "--m57-whatson-header-primary-color": BackgroundColorHex
  } : {
    "--m57-whatson-header-color": 'var(--main-color-text)',
    "--m57-whatson-header-primary-color": selectedPrimaryColor
  };
  var breadcrumbColor = BackgroundColorHex ? ColorHex : 'var(--main-color-text)';
  var GradientColor = get(params, 'GradientColorHex') || '';
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var filtersAnalytics = fields.data.filtersAnalytics;
  var gradient = null;
  var start = BackgroundColorHex;
  var end = GradientColor;
  if (BackgroundColorHex && BackgroundColorHex.length && GradientColor && GradientColor.length) {
    // @ts-ignore
    start = BackgroundColorHex;
    // @ts-ignore
    end = GradientColor;
    gradient = "w1ygirz3";
  }
  React.useEffect(function () {
    if (GradientColor && GradientColor.length) {
      if (typeof window !== 'undefined') document.querySelector('body').classList.add('colored');
    } else {
      if (typeof window !== 'undefined') document.querySelector('body').classList.remove('colored');
    }
  }, []);
  React.useEffect(function () {
    var style;
    if (breadcrumbColor) {
      style = document.createElement('style');
      style.innerHTML = ":root{--breadcrumb--color: ".concat(breadcrumbColor, ";}");
      document.querySelector('head').appendChild(style);
    }
    return function () {
      style && document.querySelector('head').removeChild(style);
    };
  }, [breadcrumbColor]);
  if (!fields) {
    console.warn('WhatsonHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [WhatsonHeader component is empty: please provide data source]");
    }
    return null;
  }
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering
    });
  };
  var renderRouteItems = function renderRouteItems() {
    if (items) {
      return items.map(function (item, index) {
        var url = get(item, 'url');
        var id = get(item, 'id');
        var title = get(item, 'navigationCategory.value.title.jss.value');
        var titleAnalitics = get(item, 'titleAnalitics.jss.value', '');
        var hasTitle = get(item, 'title.jss.value') && get(item, 'navigationCategory.value.title.jss.value');
        return /*#__PURE__*/React.createElement(React.Fragment, null, url && hasTitle ? /*#__PURE__*/React.createElement("div", {
          key: id,
          className: "g-checkbox__item ".concat(contextLink === url ? 'g-checkbox__item--active' : ''),
          "data-id": index
        }, /*#__PURE__*/React.createElement(RouterLink, {
          className: "body-small g-checkbox__label ",
          onClick: function onClick() {
            tealiumClickFunc(tealiumMergeClickData(filtersAnalytics, params), titleAnalitics);
          },
          href: url,
          title: title
        }, title)) : null, ' ');
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: GradientColor && gradient && GradientColor.length ? gradient : '',
    rtl: rtl,
    style: {
      '--startColor': start,
      '--endColor': end
    },
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__gti header__full-width-mob whatson-header",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__gti-info-sec  ".concat(!themeColor ? theme ? 'themed-box' : '' : 'themed-box', " ").concat(!themeColor ? theme ? 'colored' : '' : GradientColor && GradientColor.length ? '' : 'has-background')
  }, /*#__PURE__*/React.createElement("div", {
    className: "row sm-row-reverse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-9 col-12"
  }, pageTitle && /*#__PURE__*/React.createElement(Text, {
    className: "header__gti-title",
    tag: "h1",
    field: fields.data.contexItem.title.jss
  }), itemsLength.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll"
  }, whatsOnItemUrl ? /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox__item ".concat(contextLink === whatsOnItemUrl ? 'g-checkbox__item--active' : '')
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "body-small g-checkbox__label ",
    href: whatsOnItemUrl,
    title: "All",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(filtersAnalytics, params), 'All');
    }
  }, mapDictionary.get('All'))) : null, renderRouteItems()), pageIntro && /*#__PURE__*/React.createElement(RichText, {
    className: "header__gti-info body-small",
    tag: "p",
    field: fields.data.contexItem.introText.jss
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-3 col-12"
  }, theme && theme.dubai_calendar_logo && /*#__PURE__*/React.createElement("div", {
    className: "header-events__themeLogo"
  }, /*#__PURE__*/React.createElement("img", {
    className: "header-events__title-img",
    src: BASE_URL + theme.dubai_calendar_logo + '?cx=0.5&cy=0.5&cw=150',
    alt: "Logo"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder())));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var className = _ref2.className,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(className ? className : '', " ").concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle),
    style: style
  }, children);
};
export var commonStyles = "c17wqilz";
export var ltrStyles = "l1csrnvy";
export var rtlStyles = "rm91lmu";
export default WhatsonHeader;